import React, { useState } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { PartnerOffering, Template } from "../../data/partner_offering";
import { PartnerConfig } from "../../offering/partner_config";
import { TemplateOfferingConfirmOrderDailyAccessV2 } from "../templates/template_offering_confirm_order_daily_access_v2";
import { TemplateOfferingConfirmOrderDailyOffice } from "../templates/template_offering_confirm_order_daily_office";
import { TemplateOfferingConfirmOrderEvent } from "../templates/template_offering_confirm_order_event";
import { TemplateOfferingConfirmOrderMeetingRoomV2 } from "../templates/template_offering_confirm_order_meeting_room_v2";
import { TemplateOfferingConfirmOrderMembership } from "../templates/template_offering_confirm_order_membership";
import { TemplateOfferingConfirmOrderRoomGallery } from "../templates/template_offering_confirm_order_room_gallery";

export default function OfferingConfirmOrderPageV2(props: {
  partnerOffering: PartnerOffering;
}) {
  const { partnerOffering } = props;
  const partnerSlug = partnerOffering.partner.partnerSlug;
  const [partner, setPartner] = useState<any>();
  import(
    `../../offering/${partnerSlug}/${partnerSlug}_partner_config.tsx`
  ).then((partner) => {
    setPartner(partner);
  });
  if (!partner) {
    return null;
  }

  const DefaultTheme = lazyWithRetry(
    () => import("../components/default_theme")
  );
  const PartnerTheme = lazyWithRetry(
    () => import(`../../offering/${partnerSlug}/${partnerSlug}_theme.tsx`)
  );
  const Analytics = lazyWithRetry(
    () => import(`../../offering/${partnerSlug}/${partnerSlug}_analytics.tsx`)
  );

  return (
    <>
      <DefaultTheme />
      <PartnerTheme />
      <Analytics />
      {
        <OfferingConfirmOrderTemplate
          partnerOffering={partnerOffering}
          partnerConfig={partner.partnerConfig}
        />
      }
    </>
  );
}

function OfferingConfirmOrderTemplate(props: {
  partnerOffering: PartnerOffering;
  partnerConfig: PartnerConfig;
}) {
  const { partnerOffering, partnerConfig } = props;
  switch (partnerOffering.template) {
    // template offering v2
    case Template.DailyOffice:
      return (
        <TemplateOfferingConfirmOrderDailyOffice
          partnerConfig={partnerConfig}
        />
      );
    case Template.DailyAccessV2:
      return (
        <TemplateOfferingConfirmOrderDailyAccessV2
          partnerConfig={partnerConfig}
        />
      );
    case Template.MeetingRoomV2:
      return (
        <TemplateOfferingConfirmOrderMeetingRoomV2
          partnerConfig={partnerConfig}
        />
      );
    case Template.EventSpace:
      return (
        <TemplateOfferingConfirmOrderEvent partnerConfig={partnerConfig} />
      );
    case Template.AddOnV2:
      return (
        <TemplateOfferingConfirmOrderDailyAccessV2
          partnerConfig={partnerConfig}
        />
      );
    case Template.Membership:
      return (
        <TemplateOfferingConfirmOrderMembership partnerConfig={partnerConfig} />
      );
    case Template.RoomGallery:
      return (
        <TemplateOfferingConfirmOrderRoomGallery
          partnerConfig={partnerConfig}
        />
      );
    default:
      throw new Error(
        "This confirmation template is not supported " +
          partnerOffering.template
      );
  }
}
